var soitworker;

function startSoitWorker() {
    if (typeof (Worker) !== "undefined") {
        try {
            if (typeof (soitworker) === "undefined") {
                soitworker = new Worker("https://www.dell.com/support/staticcdn/worker/js/1.0/worker.min.js");
            }
            soitworker.postMessage({ "args": [JSON.stringify(Dell)] });
            soitworker.onmessage = function(event) {
                window.searchAutosuggestProductDetails = event.data;
                stopSoitWorker();
            };
        } catch (e) {
            //console.log(e);
        }
    } else {
        console.log("No Web Worker");
    }
}

function stopSoitWorker() {
    soitworker.terminate();
    soitworker = undefined;
}

if (typeof (Dell) !== 'undefined' &&
    typeof (Dell.OnlineUtils) !== 'undefined' &&
    typeof (Dell.OnlineUtils.AppSettings) !== 'undefined' &&
    typeof (Dell.OnlineUtils.AppSettings.Search) !== 'undefined' &&
    typeof (Dell.OnlineUtils.AppSettings.Search.AutosuggestJsUrl) !== 'undefined' &&
    typeof (window.searchAutosuggestProductDetails) === 'undefined') {
    startSoitWorker();
}